'use client';

import RichTextRenderer from 'ui/components/RichTextRenderer/RichTextRenderer';
import { Button } from 'ui';
import type { ComponentUpsellSection } from '../../graphql/generated/types';
import { useUserStore } from '../../stores/StoreProvider';
import Link from '@/components/Link';

const Upsell = ({
  headingText,
  descriptionText,
  image,
  linkHref,
  linkText,
}: ComponentUpsellSection): JSX.Element | null => {
  const strap = useUserStore((state) => state.strap);
  if (!linkHref || strap) return null;

  return (
    <div className='mt-8 w-full'>
      <div className='mx-auto flex max-w-full flex-col items-center justify-center gap-8 rounded-3xl bg-gray-200 p-4 md:max-w-[70vw] md:flex-row md:gap-12'>
        <div className='min-w-0 flex-1'>
          <div className='ml-0 h-[360px] overflow-hidden sm:-mt-16 sm:h-[450px] md:-mt-24 md:ml-6 md:h-[500px]'>
            {image?.url ? (
              <img
                alt={image.description ?? ''}
                className='mx-auto block h-full w-full object-contain'
                src={image.url}
              />
            ) : null}
          </div>
        </div>
        <div className='flex min-w-0 flex-1 flex-col gap-6 p-4'>
          <h1 className='m-0 text-[40px] font-bold normal-case leading-[44px] tracking-normal md:text-[48px] md:leading-[52px] lg:text-[52px] lg:leading-[58px]'>
            {headingText}
          </h1>
          <div className='text-lg'>
            {descriptionText?.json ? (
              <RichTextRenderer content={descriptionText.json} />
            ) : null}
          </div>

          <Button asChild size='medium' variant='secondary'>
            <Link href={linkHref}>{linkText}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Upsell;
